import { ReactComponent as ArrowDownIcon } from "../../Assets/Icons/ArrowDownIcon.svg";
import { ColorScheme } from "../../Themes/ColorScheme";

export const SortingArrow = ({ order }) => (
	<ArrowDownIcon
		stroke={ColorScheme.black}
		style={{
			marginLeft: "5px",
			transition: "all 0.3s ease",
			transform: `rotate(${order ? 0 : "0.5turn"})`
		}}
	/>
);
